import * as React from 'react';
import styled from 'styled-components';

const DocumentalRowWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colorSplit};
  border-bottom: 1px solid ${({ theme }) => theme.colorSplit};
  margin-bottom: -1px;
  padding: 4px 0;
  padding-left: 8px;
  &.is-root-dossier {
    /* font-weight: bold; */
    .ant-btn {
      font-size: 16px;
    }
    // è anche la prima riga
    border-top: none;
    padding-top: 0;
  }
  &:hover {
    background-color: ${({ theme }) => theme.controlItemBgHover};
    .ant-btn {
      &:hover {
        color: ${({ theme }) => theme.colorPrimary};
      }
    }
  }
  &.empty-dossier {
    padding: 6px 12px;
    &:hover {
      background-color: ${({ theme }) => theme.colorBgContainer};
      color: ${({ theme }) => theme.colorText};
    }
  }
`;

export interface IDocumentalRowProps
  extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Riga di documenti o folder.
 */
export function DocumentalRow(props: IDocumentalRowProps) {
  return <DocumentalRowWrapper {...props} />;
}
